import React from 'react';
import { connect } from 'react-redux';
import axiosInstance from '../main/axios';
import {
  normalizeCameraUrl,
  cameraHostFromEndereco,
  getCameraPortalAuth,
  setCameraPortalAuth,
  clearCameraPortalAuth,
  buildCameraMjpegStreamUrl,
  buildDirectMjpegStreamCandidates,
  appendCacheBustToUrl,
  cameraStreamViaServidor,
} from '../camera/cameraConfig';

const TIPO_LABEL = {
  deteccao: 'Detecção',
  monitoramento: 'Monitoramento',
};

class MapaControladorGavetaCameras extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      cameras: [],
      carregando: true,
      erro: null,
      previewErro: {},
      previewErroMsg: {},
      authForms: {},
      streamTick: {},
      directStreamIndex: {},
      streamMode: {},
      streamIniciando: {},
    };
    this.carregarCameras = this.carregarCameras.bind(this);
    this.handleDirectStreamError = this.handleDirectStreamError.bind(this);
    this.handleProxyStreamError = this.handleProxyStreamError.bind(this);
  }

  componentDidMount() {
    this.carregarCameras();
  }

  componentDidUpdate(prevProps) {
    if (this.props.controladorId !== prevProps.controladorId) {
      this.carregarCameras();
    }
  }

  carregarCameras() {
    const { controladorId } = this.props;
    if (!controladorId) {
      this.setState({ cameras: [], carregando: false, erro: null });
      return;
    }

    this.setState({
      carregando: true,
      erro: null,
      previewErro: {},
      previewErroMsg: {},
      streamTick: {},
      directStreamIndex: {},
      streamMode: {},
      streamIniciando: {},
      authForms: {},
    });
    axiosInstance
      .get('/cameras', { params: { controlador_id: controladorId, ativo: 1 } })
      .then(resp => {
        const lista = Array.isArray(resp.data) ? resp.data : [];
        const previewErro = {};
        const streamTick = {};
        const streamMode = {};
        const authForms = {};
        lista.forEach(cam => {
          const host = cameraHostFromEndereco(cam.endereco);
          const stored = host ? getCameraPortalAuth(host) : null;
          if (stored && stored.user) {
            authForms[cam.id] = { user: stored.user, pass: stored.pass || '' };
          }
          const auth = stored && stored.user ? stored : null;
          if (auth && auth.user) {
            streamTick[cam.id] = 1;
            streamMode[cam.id] = this.initialStreamMode(cam);
          } else {
            previewErro[cam.id] = 'auth';
          }
        });
        this.setState({
          cameras: lista,
          carregando: false,
          erro: null,
          previewErro,
          streamTick,
          streamMode,
          authForms,
        });
      })
      .catch(() => {
        this.setState({ cameras: [], carregando: false, erro: 'Não foi possível carregar as câmeras.' });
      });
  }

  initialStreamMode(camera) {
    if (cameraStreamViaServidor(camera.endereco)) return 'proxy';
    const auth = this.resolveAuth(camera, null);
    if (buildDirectMjpegStreamCandidates(camera.endereco, auth).length > 0) return 'direct';
    return 'proxy';
  }

  resolveAuth(camera, authOverride) {
    if (authOverride && authOverride.user) return authOverride;
    const host = cameraHostFromEndereco(camera.endereco);
    return host ? getCameraPortalAuth(host) : null;
  }

  /** Valores visíveis nos inputs (state + login salvo por host). */
  resolveFormAuth(camera) {
    const host = cameraHostFromEndereco(camera.endereco);
    const stored = host ? getCameraPortalAuth(host) : null;
    const formState = this.state.authForms[camera.id];
    const user = (
      formState && formState.user !== undefined && formState.user !== null
        ? formState.user
        : stored
          ? stored.user
          : ''
    ).trim();
    const pass =
      formState && formState.pass !== undefined && formState.pass !== null
        ? formState.pass
        : stored
          ? stored.pass || ''
          : '';
    return { host, user, pass };
  }

  handleAuthField(cameraId, field, value) {
    this.setState(prev => ({
      authForms: {
        ...prev.authForms,
        [cameraId]: { ...(prev.authForms[cameraId] || {}), [field]: value },
      },
    }));
  }

  aplicarInicioStream(camera, auth) {
    this.setState(prev => ({
      previewErro: { ...prev.previewErro, [camera.id]: null },
      previewErroMsg: { ...prev.previewErroMsg, [camera.id]: null },
      streamIniciando: { ...prev.streamIniciando, [camera.id]: false },
      authForms: { ...prev.authForms, [camera.id]: { user: auth.user, pass: auth.pass } },
      directStreamIndex: { ...prev.directStreamIndex, [camera.id]: 0 },
      streamMode: {
        ...prev.streamMode,
        [camera.id]: cameraStreamViaServidor(camera.endereco)
          ? 'proxy'
          : buildDirectMjpegStreamCandidates(camera.endereco, auth).length
            ? 'direct'
            : 'proxy',
      },
      streamTick: { ...prev.streamTick, [camera.id]: (prev.streamTick[camera.id] || 0) + 1 },
    }));
  }

  parsePreviewErro(err) {
    let msg =
      'Não foi possível autenticar ou alcançar a câmera. Confira usuário/senha e se o servidor alcança o IP/túnel.';
    const data = err.response && err.response.data;
    if (data) {
      try {
        const text = typeof data === 'string' ? data : new TextDecoder().decode(data);
        const parsed = JSON.parse(text);
        if (parsed.errors && parsed.errors[0]) msg = parsed.errors[0];
      } catch (_) {
        /* ignore */
      }
    }
    return msg;
  }

  iniciarStream(camera) {
    const { host, user, pass } = this.resolveFormAuth(camera);
    if (!host) return;
    if (!user) {
      this.setState(prev => ({
        previewErro: { ...prev.previewErro, [camera.id]: 'auth' },
        previewErroMsg: { ...prev.previewErroMsg, [camera.id]: 'Informe o usuário da câmera.' },
      }));
      return;
    }

    setCameraPortalAuth(host, user, pass);
    const auth = { user, pass };

    this.setState(prev => ({
      streamIniciando: { ...prev.streamIniciando, [camera.id]: true },
      previewErro: { ...prev.previewErro, [camera.id]: null },
      previewErroMsg: { ...prev.previewErroMsg, [camera.id]: null },
    }));

    const viaServidor = cameraStreamViaServidor(camera.endereco);
    if (!viaServidor) {
      this.aplicarInicioStream(camera, auth);
      return;
    }

    axiosInstance
      .get(`/cameras/${camera.id}/preview`, {
        params: { camera_user: user, camera_pass: pass },
        responseType: 'arraybuffer',
        timeout: 20000,
      })
      .then(() => {
        this.aplicarInicioStream(camera, auth);
      })
      .catch(err => {
        this.setState(prev => ({
          streamIniciando: { ...prev.streamIniciando, [camera.id]: false },
          previewErro: { ...prev.previewErro, [camera.id]: 'fail' },
          previewErroMsg: { ...prev.previewErroMsg, [camera.id]: this.parsePreviewErro(err) },
        }));
      });
  }

  handleDirectStreamError(camera) {
    const auth = this.resolveAuth(camera, null);
    const candidates = buildDirectMjpegStreamCandidates(camera.endereco, auth);
    this.setState(prev => {
      const idx = prev.directStreamIndex[camera.id] || 0;
      const nextIdx = idx + 1;
      if (nextIdx < candidates.length) {
        return {
          directStreamIndex: { ...prev.directStreamIndex, [camera.id]: nextIdx },
          streamTick: { ...prev.streamTick, [camera.id]: (prev.streamTick[camera.id] || 0) + 1 },
        };
      }
      return {
        streamMode: { ...prev.streamMode, [camera.id]: 'proxy' },
        directStreamIndex: { ...prev.directStreamIndex, [camera.id]: 0 },
        streamTick: { ...prev.streamTick, [camera.id]: (prev.streamTick[camera.id] || 0) + 1 },
      };
    });
  }

  handleProxyStreamError(cameraId) {
    this.setState(prev => ({
      previewErro: { ...prev.previewErro, [cameraId]: 'fail' },
    }));
  }

  pararStream(cameraId) {
    this.setState(prev => {
      const nextTick = { ...prev.streamTick };
      delete nextTick[cameraId];
      return {
        streamTick: nextTick,
        previewErro: { ...prev.previewErro, [cameraId]: null },
        previewErroMsg: { ...prev.previewErroMsg, [cameraId]: null },
      };
    });
  }

  renderAuthForm(camera, isStreaming) {
    const { user, pass } = this.resolveFormAuth(camera);
    const iniciando = this.state.streamIniciando[camera.id];

    return (
      <div
        className={`mapa-controlador-gaveta-camera-auth${isStreaming ? ' mapa-controlador-gaveta-camera-auth--live' : ''}`}
      >
        <div className="mapa-controlador-gaveta-camera-auth-fields">
          <input
            type="text"
            className="form-control input-sm"
            placeholder="Usuário"
            value={user || ''}
            onChange={e => this.handleAuthField(camera.id, 'user', e.target.value)}
            autoComplete="username"
          />
          <input
            type="password"
            className="form-control input-sm"
            placeholder="Senha"
            value={pass || ''}
            onChange={e => this.handleAuthField(camera.id, 'pass', e.target.value)}
            autoComplete="current-password"
          />
          <button
            type="button"
            className="btn btn-primary btn-sm"
            disabled={iniciando}
            onClick={() => this.iniciarStream(camera)}
          >
            {iniciando ? (
              <>
                <i className="fa fa-spinner fa-spin" /> Conectando…
              </>
            ) : (
              'Iniciar vídeo'
            )}
          </button>
          {isStreaming ? (
            <button type="button" className="btn btn-default btn-sm" onClick={() => this.pararStream(camera.id)}>
              Parar vídeo
            </button>
          ) : null}
          {!isStreaming && this.resolveFormAuth(camera).host ? (
            <button
              type="button"
              className="btn btn-default btn-sm"
              onClick={() => {
                const h = cameraHostFromEndereco(camera.endereco);
                if (h) clearCameraPortalAuth(h);
                this.setState(prev => {
                  const nextTick = { ...prev.streamTick };
                  delete nextTick[camera.id];
                  return {
                    authForms: { ...prev.authForms, [camera.id]: { user: '', pass: '' } },
                    previewErro: { ...prev.previewErro, [camera.id]: 'auth' },
                    streamTick: nextTick,
                    streamMode: { ...prev.streamMode, [camera.id]: undefined },
                  };
                });
              }}
            >
              Limpar login salvo
            </button>
          ) : null}
        </div>
      </div>
    );
  }

  resolveStreamSrc(camera) {
    const auth = this.resolveAuth(camera, null);
    const apiToken = this.props.apiToken;
    const tick = this.state.streamTick[camera.id] || 0;
    const erro = this.state.previewErro[camera.id];
    if (!auth || !auth.user || tick <= 0 || erro === 'auth' || erro === 'fail') {
      return { src: null, mode: null };
    }

    const mode = this.state.streamMode[camera.id] || 'direct';
    if (mode === 'proxy' && apiToken) {
      return {
        src: buildCameraMjpegStreamUrl(camera.id, auth, apiToken, tick),
        mode: 'proxy',
      };
    }

    const candidates = buildDirectMjpegStreamCandidates(camera.endereco, auth);
    const idx = this.state.directStreamIndex[camera.id] || 0;
    const base = candidates[idx];
    if (base) {
      return { src: appendCacheBustToUrl(base, tick), mode: 'direct' };
    }

    if (apiToken) {
      return {
        src: buildCameraMjpegStreamUrl(camera.id, auth, apiToken, tick),
        mode: 'proxy',
      };
    }
    return { src: null, mode: null };
  }

  renderPreview(camera) {
    const url = normalizeCameraUrl(camera.endereco);
    const erro = this.state.previewErro[camera.id];
    const { src: streamSrc, mode: streamMode } = this.resolveStreamSrc(camera);

    if (streamSrc) {
      const onError =
        streamMode === 'proxy'
          ? () => this.handleProxyStreamError(camera.id)
          : () => this.handleDirectStreamError(camera);

      return (
        <div className="mapa-controlador-gaveta-camera-preview mapa-controlador-gaveta-camera-preview--live">
          <img
            alt={camera.descricao}
            className="mapa-controlador-gaveta-camera-img mapa-controlador-gaveta-camera-img--stream"
            src={streamSrc}
            onError={onError}
          />
          {this.renderAuthForm(camera, true)}
        </div>
      );
    }

    return (
      <div className="mapa-controlador-gaveta-camera-preview mapa-controlador-gaveta-camera-preview--portal">
        {this.renderAuthForm(camera, false)}
        {erro === 'fail' || erro === 'auth' ? (
          <p className="mapa-controlador-gaveta-camera-auth-hint mapa-controlador-gaveta-camera-auth-hint--erro">
            {this.state.previewErroMsg[camera.id] ||
              (erro === 'auth'
                ? 'Informe usuário e senha e clique em Iniciar vídeo.'
                : 'Não foi possível abrir o MJPEG. Confira login e se o servidor alcança o IP/túnel.')}
          </p>
        ) : null}
        {url ? (
          <a href={url} target="_blank" rel="noopener noreferrer" className="btn btn-default btn-sm">
            <i className="fa fa-external-link-alt" /> Abrir painel
          </a>
        ) : null}
      </div>
    );
  }

  render() {
    const { cameras, carregando, erro } = this.state;

    if (carregando) {
      return (
        <section className="mapa-controlador-gaveta-section">
          <h4>Câmeras</h4>
          <p className="mapa-controlador-gaveta-hint">
            <i className="fa fa-spinner fa-spin" /> Carregando…
          </p>
        </section>
      );
    }

    if (erro) {
      return (
        <section className="mapa-controlador-gaveta-section">
          <h4>Câmeras</h4>
          <p className="mapa-controlador-gaveta-erro">{erro}</p>
        </section>
      );
    }

    if (!cameras.length) {
      return (
        <section className="mapa-controlador-gaveta-section">
          <h4>Câmeras</h4>
          <p className="mapa-controlador-gaveta-hint">Nenhuma câmera ativa vinculada a este controlador no cadastro.</p>
        </section>
      );
    }

    return (
      <section className="mapa-controlador-gaveta-section mapa-controlador-gaveta-section--cameras">
        <h4>Câmeras ({cameras.length})</h4>
        <div className="mapa-controlador-gaveta-camera-list">
          {cameras.map(camera => {
            const url = normalizeCameraUrl(camera.endereco);
            return (
              <article key={camera.id} className="mapa-controlador-gaveta-camera-card">
                <div className="mapa-controlador-gaveta-camera-card-head">
                  <div>
                    <strong>{camera.descricao}</strong>
                    <span className="mapa-controlador-gaveta-camera-tipo">
                      {TIPO_LABEL[camera.tipo] || camera.tipo}
                    </span>
                  </div>
                  {url ? (
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mapa-controlador-gaveta-camera-link"
                      title="Abrir painel em nova aba"
                    >
                      <i className="fa fa-external-link-alt" />
                    </a>
                  ) : null}
                </div>
                {this.renderPreview(camera)}
              </article>
            );
          })}
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  apiToken: state.auth && state.auth.user && state.auth.user.token,
});

export default connect(mapStateToProps)(MapaControladorGavetaCameras);
